export const setItemToLocalStorage = (key, value) => {
    if (typeof window === "undefined") {
        console.error("window is undefined");
    }
    localStorage.setItem(key, JSON.stringify(value));
};

export const removeItemFromLocalStorage = (key) => {
    if (typeof window === "undefined") {
        console.error("window is undefined");
    }
    localStorage.removeItem(key);
};

export const getItemFromLocalStorage = (key) => {
    if (typeof window === "undefined") {
        console.error("window is undefined");
    }
    try {
        return JSON.parse(localStorage.getItem(key));
    } catch (e) {
        console.error(e);
    }
};
